import React from 'react';
import "./Policy.css";
import { Helmet } from "@dr.pogodin/react-helmet";

function PrivacyPolicy() {
  return (
    <div className='ppMn'>
      <Helmet>
        <title>Privacy Policy | PAYTECH ADVISOR</title>
      </Helmet>

      <div className="ppCon">
        <div className="maxW">
          <h1>Privacy Policy</h1>

          <div className="ppSection">
            <h2>Information Collected</h2>
            <ul>
              <li><strong>Personal Data:</strong> Name, email, phone number, company details.</li>
              <li><strong>Business Data:</strong> KYC documents and business information shared via website, email, WhatsApp, or other official channels.</li>
              <li><strong>Usage Data:</strong> Analytics, cookies, and browsing information.</li>
            </ul>
          </div>

          <div className="ppSection">
            <h2>Use of Data</h2>
            <ul>
              <li>To deliver consulting and advisory services.</li>
              <li>To send service updates and marketing communications (only with consent).</li>
              <li>To comply with legal and regulatory requirements.</li>
            </ul>
          </div>

          <div className="ppSection">
            <h2>Data Sharing</h2>
            <ul>
              <li>Paytech Advisors does not sell or trade user data.</li>
              <li>Data may be shared with trusted partners only for service facilitation.</li>
              <li>Information may be disclosed if required by law.</li>
            </ul>
          </div>

          <div className="ppSection">
            <h2>Data Security</h2>
            <ul>
              <li>Industry-standard security measures are in place.</li>
              <li>However, no online system can be guaranteed as 100% secure.</li>
            </ul>
          </div>

          <div className="ppSection">
            <h2>User Rights</h2>
            <ul>
              <li>Users may request access, correction, or deletion of their personal data.</li>
              <li>Opt-out options are available for marketing communications.</li>
            </ul>
          </div>

          <div className="ppSection">
            <h2>Cookies</h2>
            <ul>
              <li>Our website uses cookies for analytics and performance tracking.</li>
              <li>Users may disable cookies via browser settings.</li>
            </ul>
          </div>

          <div className="ppSection">
            <h2>Updates</h2>
            <ul>
              <li>The Privacy Policy may be revised periodically, with updates posted along with the new effective date.</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy;
